export default "__VITE_ASSET__BupN$WGB__"